import { css } from '@emotion/react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TextCutter, Icon, Button, Form } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { MarketplaceFormValues, MarketplaceFormKeys } from '../types';

interface ReferralCodeUploadFieldProps {
  disabled?: boolean;
  className?: string;
  openCouponModal: () => void;
}

export const ReferralCodeUploadField = ({ className, disabled, openCouponModal }: ReferralCodeUploadFieldProps) => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext<MarketplaceFormValues>();

  const couponUploadFilesValue = watch(MarketplaceFormKeys.couponUploadFiles);
  const couponFileNames = (() => {
    const fileNames: string[] = [];

    couponUploadFilesValue.forEach((file) => {
      const decodeUrl = decodeURI(file);
      fileNames.push(decodeUrl.substring(decodeUrl.lastIndexOf('/') + 1));
    });

    return fileNames;
  })();

  return (
    <Form.Field className={className}>
      <p css={{ fontSize: '12px' }}>{t('TrackingSettings.ReferralDescription')}</p>
      <p css={{ fontSize: '12px', color: 'tomato', marginTop: '8px' }}>
        {t('Note that uploading enough amount of referral codes so that a lot of influencers will join')}
      </p>

      {couponFileNames.length > 0
        ? couponFileNames.map((fileName, index) => (
            <div css={styles.uploadedFile} key={index}>
              <Icon icon="file" variant="gray" className="mr-1.5" size="14px" />
              <TextCutter css={{ fontSize: '14px' }} text={fileName} />
              {!disabled ? (
                <Icon
                  size="10px"
                  icon="close"
                  variant="gray"
                  className="ml-auto cursor-pointer"
                  onClick={() => {
                    const newCouponUploadFilesValue = [...couponUploadFilesValue];
                    newCouponUploadFilesValue.splice(index, 1);
                    setValue(MarketplaceFormKeys.couponUploadFiles, newCouponUploadFilesValue);
                  }}
                />
              ) : null}
            </div>
          ))
        : null}

      <Button variant="outline" onClick={openCouponModal} title={t('Upload CSV')} className="mt-2 px-6" />
    </Form.Field>
  );
};
const styles = {
  uploadedFile: css({
    display: 'flex',
    padding: '16px',
    marginTop: '8px',
    borderRadius: '5px',
    alignItems: 'center',
    border: THEME.border.base,
    backgroundColor: THEME.background.colors.gray.lv1
  })
};
